import { useContext } from 'react'
import { ThemeContext } from 'styled-components/macro'

function useTheme () {
  return useContext(ThemeContext)
}

export default useTheme
